import './App.css';
import { BrowserRouter, Routes, Route } from 'react-router-dom';

import Header from './components/Header';
import Footer from "./components/Footer";
import Hero from './components/Hero';
import Main from './components/Main';
import HowItWorks from "./components/HowItWorks";

import Privacy from './components/Privacy';
import Terms from './components/Terms';
import NotFound from './components/NotFound';
import Ad from "./components/Ad";

function Home() {
  return (
    <>
      <Header />
      <Hero />
      {/* <Ad /> */}
      <HowItWorks />
      <Main />
      <Footer />
    </>
  );
}

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <Routes>

          <Route path="/" element={<Home />} />

          <Route path="/privacy-policy" element={
          <>
            <Header />
            <br />
            <br />
            <br />
            <br />
            <br />
            <Privacy />
            <Footer />
          </>} />

          <Route path="/terms-of-service" element={
          <>
            <Header />
            <br />
            <br />
            <br />
            <br />
            <br />
            <Terms />
            <Footer />
          </>} 
          />
          <Route path="*" element={<NotFound />} />

        </Routes>
      </BrowserRouter>
    </div>
  );
}

export default App;